import { normalize, schema, denormalize } from 'normalizr';

const contact = new schema.Entity('contacts', {}, { idAttribute: 'id' });

export function normalizeDatos(myData) {
  const mySchema = { contacts: [contact] };
  const normalizedData = normalize(myData, mySchema);
  return normalizedData;
}

export function normalizeDato(myData) {
  const mySchema = contact;
  const normalizedData = normalize(myData, mySchema);

  return normalizedData;
}

export function denormalizeDato(myData, store) {
  const mySchema = contact;

  const normalizedData = denormalize(myData, mySchema, store);

  return normalizedData;
}

export default contact;
